import React, {useContext, useState}from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonContent, IonButton, IonImg, IonFooter, IonHeader } from '@ionic/react';
import { Document, Page } from 'react-pdf';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../../../../css/qavaApp.css';


export function ViewInvoiceModal_Application(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [selectedFile, setSelectedFile] = useState(null);
    const [fileLocation, setFileLocation ] = useState(null);


    function uploadResume()
    {
        let formData = new FormData();
        formData.append('Tracker', '74300_resume');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xJobRequisitionID', props.data.requisitionID);
        formData.append('xJobApplicationID', props.data.applicationID);
        formData.append('xResume', selectedFile);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,

            
            // body: JSON.stringify({
            //     Tracker: '74300_Pic',
            //     user: acctID,
            //     xInventoryRoomID: props.data.roomID,
            //     xRoomImageNumber: roomImageNumber,
            //     xImageFile: selectedFile,
            //     xEnterAdminPassword: enteredPassword,
            //     sessionID: sessionID,

            // }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function closeModalHandler() {

        props.closeModal(false);
    }

    async function openPDF(){
        //window.open(props.data.fileLocation);

        const uriResult = await Filesystem.getUri({
            directory: Directory.Data,
            path: props.data.fileLocation,
          });
    
          // the path to the file
          const path = uriResult.uri;

          alert(path);
    
          // convert to capacitor//
          const localFileURL = Capacitor.convertFileSrc(path);

          alert(localFileURL);
          setFileLocation(localFileURL);

    }

    function openBroswer(){
        //window.open(props.data.fileLocation);

        //alert( baseURL+props.data.fileLocation);

        Browser.open({ url: baseURL+props.data.fileLocation}).then(() => {});

    }


    function handleFileChange(event) {

        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
    }

    //alert('TEST - Inside View Invoice');
    //alert(props.data.fileLocation);
    //alert( baseURL+props.data.fileLocation);


    return (
    <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonGrid >
                <IonRow>
                    <IonCol> Room ID</IonCol>
                    <IonCol> Price Per Night</IonCol>
                </IonRow>
                <IonRow>
                    <IonCol> {props.data.roomID} </IonCol>
                    <IonCol> {props.data.roomSalePrice} </IonCol>
                </IonRow>
            </IonGrid >
            <IonGrid >
                <IonRow>
                    <IonCol>
                        <IonButton onClick={openBroswer}>Open PDF</IonButton>
                        {/*<IonButton href={props.data.fileLocation}>View Invoice</IonButton>
                        <IonButton href={baseURL+'fileServer/merchants/bluefin_6569/forms/temp/'+props.data.fileLocation}>View Invoice Href</IonButton>
                        <object data={props.data.fileLocation} type="application/pdf" width='100%' height='100%'>
                            <p>Alternative text - include a link <a href={props.data.fileLocation}>to the PDF!</a></p>
                        </object>
                        <Document file={props.data.fileLocation}>
                            <Page pageNumber='1'></Page>
                        </Document>

                                <iframe
                                    width='100%'
                                    height='100%'
                                    src={props.data.fileLocation}
                                >
                                </iframe>*/}
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <input
                            type="file"
                            accept=".doc, .docx, .pdf"
                            onChange={handleFileChange}
                        />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonButton onClick={() => uploadResume()}> Submit Upload </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
            <IonFooter className='modal_footer_button_center'>
                <IonButton onClick={closeModalHandler}> Close </IonButton>
            </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}